// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
// $FlowFixMe
import ArrowUp from '../../../assets/images/company/stakeholders/arrow_up.svg';
// $FlowFixMe
import ArrowUpMuted from '../../../assets/images/company/stakeholders/arrow_up_muted.svg';
// $FlowFixMe
import ArrowDown from '../../../assets/images/company/stakeholders/arrow_down.svg';

const displayDefaultData = {
  board_member: 1,
  industry_name: 1,
  closing_month: 1,
  investments_tran_on: 1,
  investments_sale_date: 0,
  investments_stock_name: 1,
  investments_status: 1,
  investments_investment_amount: 1,
  investments_sale_amount: 0,
  investments_stock_price: 1,
  investments_exit_price: 0,
  investment_summaries_book_value: 1,
  stock_price: 1,
  total_stock_quantity: 1,
  total_stock_quantity_include_potential: 0,
  investment_summaries_total_stock_quantity: 1,
  investment_summaries_stock_quantity_ratio: 1,
  investment_summaries_stock_quantity_ratio_include_potential: 0,
  investment_staff_user_name: 1,
  assessment: 1,
  created_at: 0,
  updated_at: 0,
};

export default class IndexView extends JQueryView {
  constructor() {
    super('#investees');

    this.initSortIcon();
    this.initDisplayDataWhenLoad();
    this.setData();
    this.initTabScroll();
  }

  /*----------------------------------
    見えないタブまでスクロールする操作
  ----------------------------------*/
  initTabScroll() {
    const targetTab = $('.nav-link.active');
    const targetTabRight = targetTab.width() + targetTab.offset().left;
    const containerWidth = $('.l-investee-main').width();
    const containerLeft = $('.l-investee-main').offset().left;
    const containerRight = containerWidth + containerLeft;
    const targetLeft = targetTab.offset().left - containerLeft;
    if (targetTabRight > containerRight) {
      $('.tab-wrapper').animate({ scrollLeft: targetLeft }, 100);
    }
  }

  /*----------------------------------
    列の表示/非表示
  ----------------------------------*/

  // 画面描画時に、表示項目の設定を反映
  initDisplayDataWhenLoad() {
    let data = localStorage.getItem('displayData');
    if (
      data === null ||
      data === undefined ||
      // 以前のリリース内容でlocalStorageに保存している場合で、keyの不足があると表示・非表示の機能で不具合が起きるため検証
      JSON.stringify(Object.keys(displayDefaultData)) !==
        JSON.stringify(Object.keys(JSON.parse(data)))
    ) {
      this.setDefaultDisplayData();
      data = localStorage.getItem('displayData');
    }
    if (data === null || data === undefined) return;
    const displayData = JSON.parse(data);
    let nonVisibleCount = 0;
    Object.keys(displayData).forEach(key => {
      if (displayData[key] === 0) {
        nonVisibleCount += 1;
        $(`.${key}`).addClass('non-visible');
        $(`#${key}-checkbox`)[0].checked = false;
      } else {
        $(`#${key}-checkbox`).val(1);
      }
    });
    if (nonVisibleCount === 0) {
      $('#check-all').val(1);
      $('#check-all')[0].checked = true;
    }
  }

  // 初めて画面を開いた人用の初期設定
  setDefaultDisplayData() {
    localStorage.setItem('displayData', JSON.stringify(displayDefaultData));
  }

  settingModalClose() {
    const dropDown = $('#setting-dropdown');
    const dropDownMenu = $('#setting-dropdown-menu');
    dropDown.removeClass('show');
    dropDown.find('div[aria-expanded]').attr('aria-expanded', false);
    dropDownMenu.removeClass('show');
  }

  // 見えているものだけにdata-targetを挿入
  setData() {
    $.each($('thead').find('th:visible'), function(index, el) {
      el.dataset.target = index;
    });
  }

  setDisplayData() {
    let displayData: any = this.getDisplayData();
    if (displayData === null || displayData === undefined) return;
    Object.keys(displayData).forEach(key => {
      let val = $(`#${key}-checkbox`).val();
      displayData[key] = Number(val);
      if (Number(val) === 0) {
        $(`.${key}`).addClass('non-visible');
        $(`#${key}-checkbox`)[0].checked = false;
      } else {
        $(`.${key}`).removeClass('non-visible');
        $(`#${key}-checkbox`)[0].checked = true;
      }
    });
    localStorage.setItem('displayData', JSON.stringify(displayData));
  }

  getDisplayData() {
    const data = localStorage.getItem('displayData');
    if (data === null || data === undefined) return;
    const displayData = JSON.parse(data);
    return displayData;
  }

  /*----------------------------------
    dropdown制御
  ----------------------------------*/

  @on({ event: 'click', selector: '#settingBtn' })
  onClickSetDisplayData() {
    this.setDisplayData();
    this.settingModalClose();
    this.setData();
  }

  @on({ event: 'click', selector: '.dropdown-menu' })
  stopPropagation(event: any) {
    event.stopPropagation();
  }

  @on({ event: 'click', selector: '#check-all' })
  onClickChangeCheckboxValue(event: any) {
    const checked = event.target.checked;
    const children = $('#setting-dropdown-menu').find('input:checkbox');
    children.each((index, child) => {
      child.value = checked ? '1' : '0';
    });
  }

  @on({ event: 'change', selector: '.check-all' })
  onChangeAllCheckOptionCheckAll(event: any) {
    const target = event.target;
    if ($(target).is(':checked')) {
      $(target)
        .parents('.dropdown-menu')
        .find('.check-single')
        .prop('checked', true);
    } else {
      $(target)
        .parents('.dropdown-menu')
        .find('.check-single')
        .prop('checked', false);
    }
  }

  @on({ event: 'change', selector: '.check-single' })
  onChangeOptionsChangeAllCheckOption(event: any) {
    const $dropdownMenu = $(event.target).parents('.dropdown-menu');
    if (
      $dropdownMenu.find('.check-single:checked').length ===
      $dropdownMenu.find('.check-single').length
    ) {
      $dropdownMenu.find('.check-all').prop('checked', true);
    } else {
      $dropdownMenu.find('.check-all').prop('checked', false);
    }
  }

  /*----------------------------------
    ヘッダーのソートアイコン切り替え
  ----------------------------------*/

  // 画面描画時にsort対象のthにimg追加
  initSortIcon() {
    const sortLinks = $('.sort_link');
    sortLinks.each(function(i, sortLink) {
      if (
        $(sortLink).hasClass('font-weight-bold') &&
        !$(sortLink).find('.sort-icon').length
      ) {
        if ($(sortLink).hasClass('desc')) {
          $(sortLink).append(
            `<div class="sort-icon"><img src='${ArrowDown}' class="arrow"></div>`,
          );
        } else if ($(sortLink).hasClass('asc')) {
          $(sortLink).append(
            `<div class="sort-icon"><img src='${ArrowUp}' class="arrow"></div>`,
          );
        }
      }
    });
  }

  @on({ event: 'mouseover', selector: 'th' })
  enterSortLink(event: any) {
    const target = $(event.currentTarget);
    const sortLink = target.find('.sort_link');
    const sortIcon = sortLink.find('.sort-icon');

    if (!sortLink.hasClass('font-weight-bold') && !sortIcon.length) {
      this.setDefaultSortIcon(sortLink);
    }
    this.enterMoveLink(target);
  }

  @on({ event: 'mouseleave', selector: 'th' })
  leaveSortLink(event: any) {
    const target = $(event.currentTarget);
    const sortLink = target.find('.sort_link');
    const sortIcon = sortLink.find('.sort-icon');

    if (!sortLink.hasClass('font-weight-bold')) {
      sortIcon.remove();
    }
    this.leaveMoveLink(target);
  }

  @on({ event: 'mouseenter', selector: '.sort-icon' })
  enterSortIcon(event: any) {
    const sortIcon = $(event.currentTarget);
    const sortLink = sortIcon.parent('.sort_link');

    if (sortLink.hasClass('font-weight-bold')) {
      sortIcon.addClass('sort-icon-hover');
    }
  }

  @on({ event: 'mouseleave', selector: '.sort-icon' })
  leaveSortIcon(event: any) {
    const sortIcon = $(event.currentTarget);
    const sortLink = sortIcon.parent('.sort_link');

    if (sortLink.hasClass('font-weight-bold')) {
      sortIcon.removeClass('sort-icon-hover');
    }
  }

  setDefaultSortIcon(sortLink: any) {
    sortLink.append(
      `<div class="sort-icon"><img src='${ArrowUpMuted}' class="arrow"></div>`,
    );
  }

  /*----------------------------------
    列の移動
  ----------------------------------*/
  enterMoveLink(target: any) {
    const num = Number(target[0].dataset['target']);
    const leftMoveLink = target.find('.left-move-link');
    const rightMoveLink = target.find('.right-move-link');
    const leftMoveIcon = leftMoveLink.find('i');
    const rightMoveIcon = rightMoveLink.find('i');

    if (!leftMoveIcon.length && !rightMoveIcon.length) {
      this.setDefaultMoveIcon(rightMoveLink, leftMoveLink, num);
    }
  }

  leaveMoveLink(target: any) {
    const leftMoveLink = target.find('.left-move-link');
    const rightMoveLink = target.find('.right-move-link');
    const leftMoveIcon = leftMoveLink.find('i');
    const rightMoveIcon = rightMoveLink.find('i');
    leftMoveIcon.remove();
    rightMoveIcon.remove();
  }

  setDefaultMoveIcon(rightMoveLink: any, leftMoveLink: any, num: number) {
    if (num !== 1) {
      leftMoveLink.append('<i class="fas fa-angle-left move-left"></i>');
    }
    const endNum = $('thead').find('th:visible').length - 1;
    if (num !== endNum) {
      rightMoveLink.append('<i class="fas fa-angle-right move-right"></i>');
    }
  }

  @on({ event: 'click', selector: '.move-right' })
  onClickMoveRight(event: any) {
    this.moveTable(event, true);
  }

  @on({ event: 'click', selector: '.move-left' })
  onClickMoveLeft(event: any) {
    this.moveTable(event, false);
  }

  moveTable(event: any, right: boolean) {
    const thEl = event.currentTarget.closest('th');
    const thNum = Number(thEl.dataset['target']);
    const thIndex = thEl.cellIndex;
    const ref = right
      ? $('thead').find(`[data-target=${thNum + 2}]`)
      : $('thead').find(`[data-target=${thNum - 1}]`);
    const tdIndex = ref.index();
    const tBody = document.getElementsByTagName('tbody')[0];
    const tHead = document.getElementsByTagName('thead')[0];
    const th = tHead.firstElementChild;

    if (th === null || th === undefined) return;

    // th要素の書き換え
    th.insertBefore(thEl, ref[0]);

    // td要素の書き換え
    $.each(tBody.rows, function(index, el) {
      const tdEl = el.cells[thIndex];
      const tdRef = el.cells[tdIndex];
      el.insertBefore(tdEl, tdRef);
    });

    // テーブル移動後にdata属性を調整する
    $.each($('thead').find('th:visible'), function(index, el) {
      el.dataset.target = index;
    });
  }

  @on({ event: 'click', selector: 'tr[data-href]' })
  click(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    window.location = $(e.currentTarget).data('href');
  }
}
